import { Flex } from "@kui-react/flex";
import { Stack } from "@kui-react/stack";
import { ThemeProvider } from '@kui-react/theme';

import { PageHeader } from '../PageHeader';
import { PageFooter } from '../PageFooter';

import './index.css';

// The page inset is a plain class rather than the `css` prop's `padding: $lg`
// so it can narrow on small screens — a stitches atomic class and an imported
// stylesheet carry equal specificity, and which one wins would come down to
// injection order.
const PageBody = ({ children }) => {
  return (
    <Flex className='page-body' css={{ flexGrow: '1' }} justify="center">{children}</Flex>
  );
};

export const Layout = ({ children, signedInUser = null }) => {
  return (
    <ThemeProvider withReset withCanvas theme='dark'>
      <Stack css={{ height: '100vh', backgroundColor: '#212121' }}>
        <PageHeader signedInUser={signedInUser} />
        <PageBody>{children}</PageBody>
        <PageFooter />
      </Stack>
    </ThemeProvider>
  );
};

export default Layout;
